import { forwardRef, useMemo } from 'react'
import { EChart, type EChartHandle } from './EChart'
import { useChartTheme } from './useChartTheme'
import { buildWaterfallOption, type WaterfallInput, type WaterfallStep } from './waterfallOption'

export interface WaterfallProps extends WaterfallInput {
  height?: number
  loading?: boolean
  ariaLabel?: string
  className?: string
  texture?: boolean
  /** Клик по ступени — провал в операции этой статьи. */
  onStepClick?: (step: WaterfallStep) => void
}

/** Ступени P&L: выручка → вычеты → М1 → реклама → М2. */
export const Waterfall = forwardRef<EChartHandle, WaterfallProps>(function Waterfall(
  { height = 320, loading, ariaLabel, className, texture, onStepClick, ...input },
  ref,
) {
  const theme = useChartTheme()
  const option = useMemo(
    () => buildWaterfallOption(input, theme),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [theme, input.steps, input.valueFormat, input.axisFormat],
  )
  return (
    <EChart
      ref={ref}
      option={option}
      height={height}
      loading={loading}
      ariaLabel={ariaLabel}
      className={className}
      texture={texture}
      onMarkClick={(params) => {
        if (params.componentType !== 'series' || params.dataIndex === undefined) return
        const step = input.steps[params.dataIndex]
        if (step) onStepClick?.(step)
      }}
    />
  )
})

export default Waterfall
